import { render, staticRenderFns } from "./ReadinessChip.vue?vue&type=template&id=f5ab29e0&scoped=true"
import script from "./ReadinessChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadinessChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReadinessChip.vue?vue&type=style&index=0&id=f5ab29e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ab29e0",
  null
  
)

export default component.exports